import React, {useState} from 'react';
import { DatePicker } from 'antd';
import { dateToString, MULTI_DATE_FORMATS, stringToDate } from '../../utils/dateUtils';

function _DatePicker({ value, onChange, ariaLabel="Select date",...props }) {
  const [datePickerOpenStatus, setDatePickerOpenStatus] = useState(false);
  return (
    <DatePicker
      aria-label={ariaLabel}
      aria-expanded={datePickerOpenStatus}
      onOpenChange={(status)=>setDatePickerOpenStatus(status)}
      format={MULTI_DATE_FORMATS}
      value={value ? stringToDate(value) : null}
      onChange={v => onChange(v ? dateToString(v) : null)}
    />
  );
}

export { _DatePicker as DatePicker };
